<!-- 预览审核页面 -->
<template>
    <div class="OutputBufferPage">
      <PreviewAudit></PreviewAudit>
    </div>
</template>

<script>
import PreviewAudit from './PreviewAudit.vue'
export default {
  data () {
    return {
    }
  },
  components: {
    PreviewAudit
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="less">
  // .OutputBufferPage{
  //   width: 100%;
  //   height: 100%;
  // }
</style>
